export const FormStates = {
  Success: "success",
  Error: "error",
  Initial: "init",
};
